<app-all-properties></app-all-properties>